<script lang="ts" module>
  import type { TeoText } from '@/teoCore/text/TeoText';
  import BrandfitAssistant from '@/ui/brandfit/BrandfitAssistant.svelte';

  import ColumnHeadline from '../../elements/column-headline/ColumnHeadline.svelte';
  import DictionaryAssistant from './Dictionary/DictionaryAssistant.svelte';
  import PerformanceComponent from './Performance/PerformanceComponent.svelte';
  import SpellCheckComponent from './SpellCheck/SpellCheckComponent.svelte';
  import StyleComponent from './Style/StyleComponent.svelte';
  import TextGeneratorView from './TextGenerator/TextGeneratorView.svelte';
  import VersionLogCard from './Versions/VersionLogCard.svelte';
</script>

<script lang="ts">
  const { teoText }: { teoText: TeoText } = $props();
  let TS = $derived(teoText.store);
</script>

{#if $TS.view !== 'new'}
  {#if $TS.view === 'performance'}
    <PerformanceComponent {teoText}></PerformanceComponent>
  {:else if $TS.view === 'brand-scanner'}
    <ColumnHeadline text="Brand-Fit Assistent" />
    <BrandfitAssistant />
  {:else if $TS.view === 'style'}
    <ColumnHeadline text="Stil" />
    <StyleComponent {teoText}></StyleComponent>
  {:else if $TS.view === 'dictionary'}
    <ColumnHeadline text="Assistent" />
    <DictionaryAssistant />
  {:else if $TS.view === 'spellcheck'}
    <ColumnHeadline text="Rechtschreibung" />
    <SpellCheckComponent {teoText}></SpellCheckComponent>
  {:else if $TS.view === 'versions'}
    <ColumnHeadline text="Analyse Historie" />
    <VersionLogCard />
  {:else if $TS.view === 'text-generator'}
    <ColumnHeadline text="Text Generator" />
    <TextGeneratorView />
  {:else}
    <ColumnHeadline text="TODO" />
  {/if}
{/if}
